import { Injectable } from '@angular/core';
import { ReferenceService } from './reference.service';
import { UserService } from './user.service';
import { TRACKING_CONSTANTS } from './tracking.constant';
import { Router } from '@angular/router';
declare var thor;

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  constructor(
    private referenceService: ReferenceService,
    private userService: UserService,
    private router: Router,
  ) { }

  pushEvent(pagename: string) {
    if (!this.userService.isMonitoringMode()) {
      thor.pushEvent('view', {
        pagename: pagename,
        site: 'SL-Pro',
        language: 'fr',
        environment: this.referenceService.staticReferences.Environment
      });
    }
  }

pushEventGA4 = (evt: string, obj: unknown): void => {
    const env = this.referenceService.staticReferences.Environment;
    obj[TRACKING_CONSTANTS.GA4.PAGE.ENV] = env;
    if (!this.userService.isMonitoringMode()) {
      thor.pushEvent(evt, obj);
    }
  }

  pushPageViewGA4 = (pageName: string) => {
    const {VIEWGA4} = TRACKING_CONSTANTS.EVENTS,
      {TITLE} = TRACKING_CONSTANTS.GA4.PAGE,
      PAGE_NAME = TRACKING_CONSTANTS.GA4.PAGENAME[pageName],
      {CATEGORY, URL} = TRACKING_CONSTANTS.GA4.PAGE,
      CATEGORY_NAME = TRACKING_CONSTANTS.GA4.CATEGORY[pageName],
      {USER} = TRACKING_CONSTANTS.GA4.PAGE,
      {UID} = TRACKING_CONSTANTS.GA4.USER,
      {STATUS} = TRACKING_CONSTANTS.GA4.USER,
      {LANGUAGE} = TRACKING_CONSTANTS.GA4.PAGE,
      {PLATFORM} = TRACKING_CONSTANTS.GA4.PAGE,
      {WEB} = TRACKING_CONSTANTS.GA4.PLATFORM,
      {SITE} = TRACKING_CONSTANTS.GA4.PAGE,
      {FR} = TRACKING_CONSTANTS.GA4.LANGUAGE;

      const Rcu = this.getRcu();

    this.pushEventGA4(VIEWGA4, {
      [TITLE]: PAGE_NAME,
      [CATEGORY]: CATEGORY_NAME,
      [URL]: this.router.url,
      [LANGUAGE]: FR,
      [PLATFORM]: WEB,
      [SITE]: 'MySLPro',
      [USER]: {
        [UID]:
        Rcu !== null ? Rcu : null,
        [STATUS]: Rcu !== null ? 'logged' : 'unlogged',
      },
    });
  }

  private getRcu(): any {
    const cookie = {};
    document.cookie.split(';').forEach(function(el) {
      const split = el.split('=');
      cookie[split[0].trim()] = split.slice(1).join('=');
    });
    const Rcu = cookie['userAccessToken'] !== undefined  ? cookie['userAccessToken'].split('+')[2] : null;
    return Rcu;
  }

}
